module.exports = __webpack_public_path__ + "static/fb2-633a9d1ede5c74f53d0acd536653c874.png";